import { React } from "react";
import { isEmpty } from "lodash";
import PropTypes from "prop-types";
import { TextInput, Box, Flex, Icon, H3, Modal } from "orcs-design-system";
import CopyToClipboard from "src/components/CopyToClipboard";

// This component is used to display the secret reveal modal for API credentials.
// It takes a prop 'visible' to control the visibility of the modal.
// The modal displays the client ID and client secret, along with a copy to
// clipboard button for each.

const SecretRevealModal = ({
  visible,
  clientId,
  clientSecret,
  onHideModal,
}) => {
  if (isEmpty(clientId) || isEmpty(clientSecret)) {
    return null;
  }
  // If clientId and clientSecret are not null or empty, render the modal
  return (
    <Modal
      visible={visible}
      onClose={() => {
        onHideModal();
      }}
      width="100%"
      height="100%"
      headerContent={<H3>API Credentials</H3>}
    >
      <br />
      <Box display="flex" flexDirection="row">
        <TextInput
          data-testid="clientId"
          value={clientId}
          disabled
          fullWidth={true}
          bold={true}
          label="Client ID"
        />
        <CopyToClipboard
          valueToCopy={clientId}
          popOverDirection="top"
          popOverWidth="106px"
        />
      </Box>
      <Box display="flex" flexDirection="row" mt="r">
        <TextInput
          data-testid="clientSecret"
          value={clientSecret}
          disabled
          fullWidth={true}
          label="Client Secret"
          bold={true}
        />
        <CopyToClipboard
          valueToCopy={clientSecret}
          popOverDirection="top"
          popOverWidth="106px"
        />
      </Box>
      <Box display="flex" flexDirection="column" mt="r">
        <Flex>
          <p>
            <Icon
              mr="3"
              icon={["fas", "info-circle"]}
              style={{ color: "red" }}
              data-testid="info-circle"
            />
            Please copy and store the client secret securely. You won&apos;t be
            able to view it again after leaving this page.
          </p>
        </Flex>
        <Flex>
          <p>
            Treat it like a password. If you lose it, you&apos;ll need to
            generate a new key pair.
          </p>
        </Flex>
      </Box>
    </Modal>
  );
};

SecretRevealModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  clientId: PropTypes.string.isRequired,
  clientSecret: PropTypes.string.isRequired,
  onHideModal: PropTypes.func.isRequired,
};

export default SecretRevealModal;
